import React from "react";

import Section from "../../../HOC/Section";

import blogImage1 from "../../../assets/img/blog1.jpg";
import blogImage2 from "../../../assets/img/blog2.jpg";
import blogImage3 from "../../../assets/img/blog3.jpg";
import block1 from "../../../assets/img/block1.jpeg";

import "./index.scss";

const Blog = () => {
  return (
    <Section id="blog">
      <div className="container pt-2 pb-5">
        <div className="section-header pt-5 pb-5 text-center">
          <h3 className="section-title">
            <span>UBC </span>特色轴承
          </h3>
          <h6 className="section-subtitle mr-auto ml-auto">
            Individualized quality care that meets the total needs of the
            patient Individualized quality care that quality care that
            Individualized quality care that meets the total.
          </h6>
        </div>
        <div className="section-content">
          <div className="row">
            <div className="col-lg-4 mb-3">
              <div className="card rounded-0">
                <img src={block1} className="card-img-top" alt="Blog 1" />
                <div className="card-body">
                  <h5 className="card-title">电机专用轴承(EMQ5)</h5>
                  <p className="card-text">
                    UBC电机专用轴承采用优质轴承钢配以先进的热处理技术，
                    钢球100%通过探伤检验，并填充了高性能的耐高温油脂。
                  </p>
                  <a href="#!" className="btn btn-sm btn-primary">
                    了解更多
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 mb-3">
              <div className="card rounded-0">
                <img src={blogImage2} className="card-img-top" alt="Blog 2" />
                <div className="card-body">
                  <h5 className="card-title">重卡传动轴专用轴承</h5>
                  <p className="card-text">
                    UBC与世界一流品牌共同研制的宽体轴承，专门应用于重型
                    卡车的传动轴部位，内外圈宽体设计，密封圈为双层结构，
                    润滑脂为耐高温油脂，摩擦力矩达到最小。
                  </p>
                  <a href="#!" className="btn btn-sm btn-primary">
                    了解更多
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 mb-3">
              <div className="card rounded-0">
                <img src={blogImage3} className="card-img-top" alt="Blog 3" />
                <div className="card-body">
                  <h5 className="card-title">圆柱滚子轴承</h5>
                  <p className="card-text">
                    UBC圆柱滚子轴承的挡边通过特殊设计和特殊加工工艺的处
                    理，有效改善了润滑、减小摩擦进而降低轴承的运行温度。
                    对保持架进行特殊设计，使用玻璃纤维加强型尼龙保持架，
                    增强了额定载荷，并能承受更高的工作温度。
                  </p>
                  <a href="#!" className="btn btn-sm btn-primary">
                    了解更多
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Blog;
